import React from 'react';
import cx from 'classnames';

import Text from '../Text';

import styles from './Initials.module.scss';
import usePresenter from './Initials.presenter';
import getProps from './Initials.props';
import { InitialsCombinedProps } from './types';


const Initials: React.FC<InitialsCombinedProps> = (props) => {
  const {
    size,
    colour,
    className,
    classes,
    text,
  } = usePresenter(props);

  const variantName = `${size}${colour}`;
  const internalProps = getProps(variantName);
  const currentStyle = styles[`initials${variantName}`];

  let componentView;

  switch (variantName) {
    case '20Amber':
    case '20Aqua':
    case '20Green':
    case '20Purple':
    case '32Amber':
    case '32Aqua':
    case '32Green':
    case '32Purple':
    case '48Amber':
    case '48Aqua':
    case '48Green':
    case '48Purple':
    case '20Default':
    case '32Default':
    case '48Default': {
      componentView = (
        <div className={cx(currentStyle, className)}>
          <Text
            className={cx(styles.text, classes?.text)}
            {...internalProps.text}
            {...text}/>
        </div>
      );
      break;
    }
    default:
      componentView = <div>�</div>;
      break;
  }

  return componentView;
};

export default Initials;

